import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in germany.template and meridian.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'tour-buchen',
  'club-facilities': 'club-einrichtung',
  'club-treatments': 'face-body-spa',
  'club-fitness': 'fitness',
  'creche': 'krippe',
  'exercise-classes': 'fitness-klassen',
  'children': 'children',
  'gym': 'geraetetraining',
  'sports': 'sports',
  'kids-classes': 'kinder-klassen',
  'pools': 'pools',
  'spa': 'wellness',
  'tennis': 'tennis',
  'enquire-now': 'jetzt-anfragen',
  'enquiry-form': 'jetzt-anfragen',
  'family-and-kids': 'familie-und-kinder',
  'golf': 'golf',
  'join-now': 'jetzt-mitglied-werden',
  'manage-your-tour': 'tour-verwalten',
  'membership-trial': 'probemitgliedschaft',
  'relax-and-socialise': 'entspannen-und-unterhalten',
  'timetable': 'stundenplan',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'personal-training',
  'join': 'mitglied-werden',
  // If this link is changed, we should:
  // - Update nginx OJ route handling
  // - Update MSS/Common in the backend
  // - Update the links stored in CC e.g. see DLLABS-10292 (or add an nginx redirect from the old route)
  'join-online': 'online-mitglied-werden',
  // TODO Redesign: Check over these translations
  'membership-type': 'mitgliedschaftsart',
  'members': 'mitglieder',
  'personal-details': 'persoenliche-daten',
  'your-price': 'ihr-preis',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'jetzt-anfragen',

  'memberships': 'mitgliedschaften',
  'terms-and-conditions': 'geschaftsbedingungen',
  'policy': 'politik',
  'gyms-in-hamburg': 'fitnessstudio-in-hamburg',
  'careers': 'karriere',
  'press': 'presse',
  'digital-signature': 'digitale-signatur',
  'young-adult': 'junger-erwachsener',
  'family': 'familie',
};
